// extracted by mini-css-extract-plugin
export default {"chip":"IssueSeverityLabel_chip__ZerfY"};